if (!customElements.get("target-card")) {
  class ComponentTargetCard extends HTMLElement {
    constructor() {
      super();
      console.log("target card");
      this.isPlaying = false;
      this.elBtnPlay = this.querySelector(".play");
      this.elBtnPause = this.querySelector(".pause");
      this.elVideo = this.querySelector(".video-element");
      this.elMediaWrap = this.querySelector(".media-wrap");
      if (this.elBtnPlay && this.elBtnPause) {
        this.initControls();
      }
    }
    playVideo(play) {
      if (play) {
        this.elMediaWrap.classList.remove("hide");
        this.elVideo.play();
        this.elBtnPlay.style.display = "none";
        this.elBtnPause.style.display = "flex";
        this.isPlaying = true;
      } else {
        this.elMediaWrap.classList.add("hide");
        this.elVideo.pause();
        this.elBtnPlay.style.display = "flex";
        this.elBtnPause.style.display = "none";
        this.isPlaying = false;
      }
    }
    initControls() {
      this.elBtnPlay.addEventListener("click", (event) => {
        event.preventDefault();
        this.playVideo(true);
      });
      this.elBtnPause.addEventListener("click", (event) => {
        event.preventDefault();
        this.playVideo(false);
      });
    }
  }
  customElements.define("target-card", ComponentTargetCard);
}
